import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { GbsonderrechtService, GrundstueckId, SonderrechtMasterDetailEntryMeta } from '../../core/gb-api';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { FormatConfigService } from '../../core/services/format-config.service';
import { CapiLoginService } from '../../core/extension/login/capi-login-service';
import { HistoryMode } from '../../core/services/HistoryMode';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { BeschreibungTableWrapperComponent } from '../../shared/components/table/beschreibung-table-wrapper.component';
import { DatumPipe } from '../../shared/pipes/simple/datum.pipe';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../shared/directives/history.directive';
import { Subscription } from 'rxjs';
import { RechtsgrundIcpComponent } from '../shared/component/rechtsgrund-icp/rechtsgrund-icp.component';

@Component({
  selector: 'cap-sonderrecht-icp',
  imports: [
    BeschreibungTableWrapperComponent,
    DatumPipe,
    ListLoaderWrapperComponent,
    TranslatePipe,
    NgTemplateOutlet,
    HistoryDirective,
    RechtsgrundIcpComponent
  ],
  templateUrl: './sonderrecht-icp.component.html',
  styleUrl: './sonderrecht-icp.component.scss'
})
export class SonderrechtIcpComponent extends AbstractComponent implements OnInit, OnChanges, OnDestroy {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<SonderrechtMasterDetailEntryMeta>;
  historischeDatenSubscription: Subscription;

  @Input()
  isEigentuemer: boolean = false;

  anzeigenHistorischeDaten: boolean = true;
  belegeAnzeigen: boolean;
  datumBelegeAnzeigen: boolean = false;

  constructor(
    private sonderrechtService: GbsonderrechtService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService,
    private appformatConfigService: FormatConfigService,
    private loginService: CapiLoginService
  ) {
    super();
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update(): void {
    const historischeDaten = this.anzeigenHistorischeDaten
      ? this.appConfigService.einstellungHistorischeDaten
      : HistoryMode.HistoryMode.OHNE_HIST;
    const timepointCtx = this.timepointService.timepointCtx;
    const observable = this.sonderrechtService.loadSonderrechtSichtGrundstueck(
      //
      this._grundstueckId.id, //
      timepointCtx.timepointIso, //
      timepointCtx.timepointId, //
      historischeDaten //
    );
    this.listLoader = new ListLoaderObservable<SonderrechtMasterDetailEntryMeta>(undefined, 1, observable);
  }

  ngOnInit(): void {
    this.addSub(
      this.appformatConfigService.parameterConfig$.subscribe((config) => {
        this.belegeAnzeigen = <any>config?.parameters.BELEGEANZEIGEN || this.isEigentuemer;
        this.datumBelegeAnzeigen = this.isEigentuemer || this.loginService.userLoggedIn;
      })
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }
}
